import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ValidationService {

    constructor() { }

    /**
     * Returns a standard error message based on the Angular validator error object.
     * @param errors The errors object from a FormControl (e.g., control.errors)
     * @param label The human-readable name of the field (e.g., 'Email Address')
     * @returns A friendly error message string
     */
    getValidatorErrorMessage(errors: any, label: string = 'Field'): string | null {
        if (!errors) return null;

        const errorKeys = Object.keys(errors);

        if (errorKeys.includes('required')) {
            return `${label} is required`;
        }

        if (errorKeys.includes('email')) {
            return `Please enter a valid email address`;
        }

        if (errorKeys.includes('minlength')) {
            return `${label} must be at least ${errors['minlength'].requiredLength} characters long`;
        }

        if (errorKeys.includes('maxlength')) {
            return `${label} cannot exceed ${errors['maxlength'].requiredLength} characters`;
        }

        if (errorKeys.includes('min')) {
            return `${label} must be at least ${errors['min'].min}`;
        }

        if (errorKeys.includes('max')) {
            return `${label} cannot exceed ${errors['max'].max}`;
        }

        if (errorKeys.includes('invalidAmount')) {
            return `${label} must be a valid amount (up to 2 decimal places)`;
        }

        if (errorKeys.includes('pattern')) {
            return `Invalid format for ${label.toLowerCase()}`;
        }

        // Default message for unknown errors
        return `Invalid value for ${label}`;
    }
}
